import * as React from "react";
import { ContainerQuery } from "react-container-query";
import { marketColumnsDisplay, marketColumnsDisplayMultiview } from "../../../../constants";
import { CardType } from "../../../../data";
import { SecondaryHeading } from "../SecondaryHeading";
import { HeadingTitle } from "../HeadingTitle";
import { HeadingNamesWrap } from "../HeadingNamesWrap";
export const CustomHeading = (props) => {
    const columnsDisplay = props.cardType === CardType.Multiview
        ? marketColumnsDisplayMultiview
        : marketColumnsDisplay;
    return React.createElement(ContainerQuery, { query: columnsDisplay }, params => {
        return (React.createElement(SecondaryHeading, { componentPrefix: props.cardType },
            React.createElement(HeadingTitle, { name: "", eventsCount: "" }),
            React.createElement(HeadingNamesWrap, { marketNames: props.marketNames, marketTemplates: props.marketTemplates, queryParams: params })));
    });
};
//# sourceMappingURL=CustomHeading.js.map